module.exports = __webpack_public_path__ + "static/MBAEX-c0d00b7e5dde2eef92a311595b8626c3.png";